/**
 * Base Cali — hero sound.
 * The hero video autoplays muted (browsers require muted for autoplay).
 *  • Sound toggle button: click to turn sound on/off.
 *  • Auto-sound ([data-hero-autosound]): browsers won't autoplay with sound, so
 *    we unmute on the first real user gesture (pointer/touch/key) — the earliest
 *    moment the browser allows audio.
 */
(function () {
  function setBtn(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', String(on));
    btn.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
  }

  function init(section) {
    if (section.dataset.heroSoundReady) return;
    section.dataset.heroSoundReady = '1';

    const btn = section.querySelector('[data-hero-sound]');
    const video = section.querySelector('video.base-hero__video');
    if (!video) return;

    // Manual toggle
    if (btn) {
      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        const soundOn = !video.muted;
        setBtn(btn, soundOn);
        if (soundOn) {
          video.volume = 1;
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      });
    }

    // Auto-unmute on the first user gesture.
    if (section.hasAttribute('data-hero-autosound')) {
      const events = ['pointerdown', 'touchstart', 'keydown'];
      const onFirst = function () {
        events.forEach(function (e) { window.removeEventListener(e, onFirst); });
        video.muted = false;
        video.volume = 1;
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
        setBtn(btn, !video.muted);
      };
      events.forEach(function (e) { window.addEventListener(e, onFirst, { passive: true }); });
    }
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-base-hero]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
